// extracted by mini-css-extract-plugin
export var quillEditor = "_nf-1";
export var variable = "_nf-0";